"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.detachValleySlsIngestUpdate = exports.attachValleySlsIngestUpdate = void 0;
const lodash_1 = require("lodash");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
/**
 * "ValleySlsIngest" is already a UI node that's present in the graph so no need to create
 * any new nodes, just need to add dependency with original raw supplemental tape.
 * This connection isn't a direct dependency since need to apply Xlsx2Csv2 first
 */
const attachValleySlsIngestUpdate = (dbGraph) => {
    const clonedDbGraph = (0, lodash_1.cloneDeep)(dbGraph);
    const { dataTapes, dataTapeDependencies } = clonedDbGraph;
    const valleySlsIngestNodes = utils.filterValleySlsIngest({
        dataTapes,
    });
    if (valleySlsIngestNodes.length === 0) {
        return dbGraph;
    }
    for (const valleySlsIngest of valleySlsIngestNodes) {
        const { artifactSlug, id } = valleySlsIngest;
        const inputTapes = utils.getAllDependencyInputTapes({
            dbGraph,
            outputArtifactId: id,
        });
        const rawSupplementTapes = utils.filterRawSupplementTapes({
            dataTapes: inputTapes,
        });
        (0, common_1.finleyAssert)(rawSupplementTapes.length >= 2, // Can be greater than 2 if there are commitment files too
        `Valley SLS Ingest node should be created by at least 2 Raw Supplemental Tapes for Note and Participant, but found ${rawSupplementTapes.length} [artifactSlug:${artifactSlug}]`);
        for (const rawSupplementTape of rawSupplementTapes) {
            dataTapeDependencies.push({
                inputArtifactId: rawSupplementTape.id,
                outputArtifactId: valleySlsIngest.id,
            });
        }
    }
    return { dataTapeDependencies, dataTapes };
};
exports.attachValleySlsIngestUpdate = attachValleySlsIngestUpdate;
/**
 * Detachment process for "ValleySlsIngest" would just be to detach
 * synthetic input dependencies ("raw supplemental tapes")
 */
const detachValleySlsIngestUpdate = (dbGraph) => {
    const clonedDbGraph = (0, lodash_1.cloneDeep)(dbGraph);
    const { dataTapes } = clonedDbGraph;
    const valleySlsIngestNodes = utils.filterValleySlsIngest({
        dataTapes,
    });
    if (valleySlsIngestNodes.length === 0) {
        return dbGraph;
    }
    let { dataTapeDependencies } = clonedDbGraph;
    for (const valleySlsIngest of valleySlsIngestNodes) {
        const assignedRepaymentTapeInputs = utils.getInputTapes({
            dbGraph: clonedDbGraph,
            outputArtifactId: valleySlsIngest.id,
        });
        const rawSupplementTapes = utils.filterRawSupplementTapes({
            dataTapes: assignedRepaymentTapeInputs,
        });
        (0, common_1.finleyAssert)(rawSupplementTapes.length >= 2, `Valley SLS Ingest Detach Synthetic: Expected at least 2 rawSupplementTapes but found ${rawSupplementTapes.length} [artifactSlug:${valleySlsIngest.artifactSlug}]`);
        for (const rawSupplementTape of rawSupplementTapes) {
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: {
                    inputArtifactId: rawSupplementTape.id,
                    outputArtifactId: valleySlsIngest.id,
                },
            });
        }
    }
    return { dataTapeDependencies, dataTapes };
};
exports.detachValleySlsIngestUpdate = detachValleySlsIngestUpdate;
exports.syntheticProcess = {
    toDb: exports.attachValleySlsIngestUpdate,
    fromDb: exports.detachValleySlsIngestUpdate,
};
//# sourceMappingURL=valleySlsIngest.js.map